import { capitalize } from "@services/format/string";

export function resolveCustomerName(customer) {
  if (!customer) {
    return { firstName: null, lastName: null };
  }
  const firstName = capitalize(customer.first_name);
  let lastName = capitalize(customer.last_name);
  if (lastName) {
    lastName += ".";
  }

  return { firstName, lastName };
}
